// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection, { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import Button from "@insite/mobius/Button";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import { SectionContainer, SectionTitle } from "@tps/App/Widgets/DesignSystem/DesignSystem.helpers";
import { longText } from "@tps/App/Widgets/DesignSystem/DummyData/DummyData";
import React, { FC } from "react";
import { css } from "styled-components";

interface AccordionsTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    accordion?: AccordionPresentationProps;
}

const accordionsTabStyles: AccordionsTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    accordion: {
        css: css`
            width: 100%;
        `,
    },
};

const styles = accordionsTabStyles;
const AccordionsTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Accordions")}</SectionTitle>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <Accordion headingLevel={4} {...styles.accordion}>
                    <ManagedAccordionSection title="Accessibility" initialExpanded={true} onTogglePanel={() => {}}>
                        <Typography as="div">{longText}</Typography>
                    </ManagedAccordionSection>
                    <AccordionSection title="Details">
                        <Typography as="div">{longText}</Typography>
                        <Button>Another Focusable Element</Button>
                    </AccordionSection>
                    <AccordionSection title="Documents">
                        <Typography as="div">{longText}</Typography>
                    </AccordionSection>
                </Accordion>
            </GridItem>
        </SectionContainer>
    );
};

export default AccordionsTab;
